import React from 'react'
import './logo.css'
import logo from '../../assets/favDoctor-logo.svg'
import { useStateValue } from '../../stateprovider';

const Logo = () => {
  const [{ menu }, dispatch] = useStateValue();

  
  return (
    <>
      <section className={(menu === true) ?'favdoc__logo favdoc__logo__Flex' : 'favdoc__logo'}><a href='/'>
        <img src={logo} alt='FavDoctor-Logo' /></a>
      </section>
    </>
  )
}

export default Logo